module.exports = __webpack_public_path__ + "img/eggplant-parmesan.895c3cda.jpg";